import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, notification, Form, Modal, Select, Space,Tooltip ,Input} from "antd";
import GenericTable from "../components/GenericTable";
import GenericDrawer from "../components/GenericModal";
import GenericViewModal from "../components/GenericViewModal";
import {
  fetchCptsRequest,
  createCptRequest,
  updateCptRequest,
  deleteCptRequest,
  fetchCptRulesRequest,
  mapCptToRuleRequest,
  deleteCptRuleMappingRequest
} from "../redux-saga/actions/cptActions ";
import ProjectNavbar from "../components/ProjectNavbar";
import { useParams } from "react-router-dom";
import { fetchRulesRequest } from "../redux-saga/actions/ruleActions";
import moment from "moment";
import { updateCurrentProjectId } from "../redux-saga/actions/customerActions";
import { EyeOutlined, EditOutlined, DeleteOutlined ,FileSearchOutlined } from "@ant-design/icons";
import {IconFileCode} from '@tabler/icons-react';

const { Option } = Select;

const cptModalInputs = [
  { label: "CPT ID", name: "cptId", type: "text" },
  { label: "Code", name: "code", type: "text" },
  { label: "Description", name: "description", type: "text" },
  { label: "Effective Date", name: "effectiveDate", type: "date" },
  { label: "Deleted Date", name: "deletedDate", type: "date" }
];

const CptPage = () => {
  const dispatch = useDispatch();
  const cpts = useSelector((state) => state.cpt.cpts?.data);
  const rules = useSelector((state) => state.cpt.rules?.data);
  const commonRules = useSelector((state) => state.rule.rules?.data);
  const { projectId } = useParams();
  const loading = useSelector((state) => state.cpt.loading);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const[currentRecord,setCurrentRecord]=useState()
  const [editingCpt, setEditingCpt] = useState(null);
  const [form] = Form.useForm();
  const [viewingCpt, setViewingCpt] = useState(null);
  const [isViewModalVisible, setIsViewModalVisible] = useState(false);
  const [isRulesModalVisible, setIsRulesModalVisible] = useState(false);
  const [selectedCpt, setSelectedCpt] = useState(null);
  const [selectedRule, setSelectedRule] = useState(null);

  const metaData = useSelector((state) => state.cpt.cpts?.meta || {});
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    dispatch(fetchCptsRequest({ page: currentPage, limit: 2, search: searchTerm }));
    dispatch(fetchRulesRequest(projectId));
    dispatch(updateCurrentProjectId(projectId));
  }, [dispatch, projectId,currentPage, searchTerm]);

  const handleCreateOrEdit = (values) => {
    if (editingCpt) {
      dispatch(updateCptRequest(editingCpt.id, values));
    } else {
      dispatch(createCptRequest(values));
    }
    notification.success({ message: "Success", description: "CPT saved successfully." });
    setIsModalVisible(false);
    setEditingCpt(null);
    form.resetFields();
  };

  const handleView = (record) => {
    const formattedRecord = {
      ...record,
      effectiveDate: record.effectiveDate ? moment(record.effectiveDate).format("YYYY-MM-DD HH:mm:ss") : null,
      deletedDate: record.deletedDate ? moment(record.deletedDate).format("YYYY-MM-DD HH:mm:ss") : null,
      createdAt: record.createdAt ? moment(record.createdAt).format("YYYY-MM-DD HH:mm:ss") : null,
      updatedAt: record.updatedAt ? moment(record.updatedAt).format("YYYY-MM-DD HH:mm:ss") : null,
    };
    setViewingCpt(formattedRecord);
    setIsViewModalVisible(true);
  };

  const handleEdit = (record) => {
    const formattedRecord = {
      ...record,
      effectiveDate: record.effectiveDate ? moment(record.effectiveDate) : null,
      deletedDate: record.deletedDate ? moment(record.deletedDate) : null,
    };
    setEditingCpt(formattedRecord);
    setIsModalVisible(true);
    form.setFieldsValue(formattedRecord);
  };

  const handleDelete = (record) => {
  Modal.confirm({
    title: "Confirm",
    content: "Are you sure you want to delete this CPT?",
    onOk: () => {
      dispatch(deleteCptRequest(record.id));
      notification.success({ message: "Success", description: "CPT deleted successfully." });
    },
    onCancel: () => {
      // Do nothing if the user cancels the confirmation
    },
  });
  };

  // Fetch rules associated with a CPT
  const handleViewRules = (record) => {
    setViewingCpt(record);
    setSelectedCpt(record.id);
    setCurrentRecord(record)
    dispatch(fetchCptRulesRequest(projectId, record.id));
    setIsRulesModalVisible(true);
  };

  // Map a selected rule to the selected CPT
  const handleMapRule = () => {
    if (selectedRule) {
      dispatch(mapCptToRuleRequest(projectId, viewingCpt.id, selectedRule));
      notification.success({ message: "Success", description: "Rule mapped to CPT successfully." });
      setSelectedRule(null);
      dispatch(fetchCptRulesRequest(projectId, currentRecord.id));
    } else {
      notification.warning({ message: "Warning", description: "Please select a rule to map." });
    }
  };

  // Delete a rule mapping
  const handleDeleteRuleMapping = (ruleId) => {
    dispatch(deleteCptRuleMappingRequest(projectId, viewingCpt.id, ruleId));
    notification.success({ message: "Success", description: "Rule mapping deleted successfully." });
    dispatch(fetchCptRulesRequest(projectId, viewingCpt.id));
  };

  const columnsConfig = [
    { title: "CPT ID", dataIndex: "cptId" },
    { title: "Code", dataIndex: "code" },
    { title: "Description", dataIndex: "description" },
    { title: "Effective Date", dataIndex: "effectiveDate" },
    { title: "Deleted Date", dataIndex: "deletedDate" },
    {
      title: "Actions",
      render: (_, record) => (
        <Space>
          <Tooltip title="View">
            <EyeOutlined style={{ fontSize: "20px", color: "#1890ff" }} onClick={() => handleView(record)} />
          </Tooltip>
          <Tooltip title="Edit">
            <EditOutlined style={{ fontSize: "20px", color: "#faad14" }} onClick={() => handleEdit(record)} />
          </Tooltip>
          <Tooltip title="Delete">
            <DeleteOutlined style={{ fontSize: "20px", color: "#f5222d" }} onClick={() => handleDelete(record)} />
          </Tooltip>
          <Tooltip title="View Rule">
          <FileSearchOutlined style={{ fontSize: "20px", color: "#f5222d" }} onClick={() => handleViewRules(record)} />  
      </Tooltip>
        </Space>
      ),
    },
  
  ];
 

  const ruleColumnsConfig = [
    { title: "Rule ID", dataIndex: "ruleId" },
    { title: "Content", dataIndex: "content" },
    {
      title: "Actions",
      render: (_, rule) => (
        <Button onClick={() => handleDeleteRuleMapping(rule.id)}>Delete Mapping</Button>
      ),
    },
  ];

  return (
    <div style={{ display: "flex", gap: "10px" }}>
      <ProjectNavbar />
      <div style={{ width: "100%" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
           <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "16px" }}>
                <IconFileCode style={{ fontSize: "24px", color: "black" }} />
                <h2 style={{ margin: 0 }}>CPT</h2>
            </div>

            <div style={{ display: "flex", justifyContent: "end", marginBottom: 11 }}>
              <Button type="primary" onClick={() => setIsModalVisible(true)}>
                Create CPT
              </Button>
            </div>
        </div>
        <Input
          placeholder="Search ICD"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ marginBottom: "16px" }}
        />
        <GenericTable data={cpts} columnsConfig={columnsConfig}  loading={loading} pagination={{
            current: metaData.page || 1,
            pageSize: metaData.limit || 2,
            total: metaData.total || 0,
            onChange: (page, pageSize) => {
              setCurrentPage(page);
              dispatch(fetchCptsRequest({ page, limit: pageSize, search: searchTerm }));
            },
          }}  />

        {/* CPT Create/Edit Drawer */}
        {isModalVisible && (
          <GenericDrawer
            isVisible={isModalVisible}
            handleCancel={() => {
              setIsModalVisible(false);
              setEditingCpt(null);
            }}
            title={
              <span style={{display : "flex",alignItems:"center"}}>
                <IconFileCode style={{ color: "white", marginRight: "8px" }} />
                {editingCpt ? "Edit CPT" : "Create CPT"}
              </span>
            }
            inputs={cptModalInputs}
            onSubmit={handleCreateOrEdit}
            predefinedData={editingCpt || {}}
          />
        )
      }

        {/* CPT View Modal */}
        {isViewModalVisible && (
          <GenericViewModal
            isVisible={isViewModalVisible}
            handleCancel={() => setIsViewModalVisible(false)}
            title="View CPT"
            data={viewingCpt}
            footerButtons={["Close"]}
            onButtonClick={() => setIsViewModalVisible(false)}
          />
        )}

        {/* Rules Modal */}
        <Modal
          title="CPT Rules"
          visible={isRulesModalVisible}
          onCancel={() => setIsRulesModalVisible(false)}
          footer={[
            <Button key="close" onClick={() => setIsRulesModalVisible(false)}>
              Close
            </Button>,
          ]}
        >
          <div style={{ display: "flex", gap: "10px" }}>
            <Select
              style={{ width: "100%", marginTop: 16, marginBottom: "10px" }}
              placeholder="Select Rule to Map"
              onChange={(value) => setSelectedRule(value)}
            >
              {commonRules?.map((rule) => (
                <Option key={rule.id} value={rule.id}>
                  {rule.ruleId}
                </Option>
              ))}
            </Select>
            <Button type="primary" style={{ marginTop: 16 }} onClick={handleMapRule}>
              Map Selected Rule
            </Button>
          </div>
          <GenericTable data={rules} columnsConfig={ruleColumnsConfig} loading={loading} />
        </Modal>
      </div>
    </div>
  );
};

export default CptPage;
